import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useFormik } from 'formik';
import { useLocation, useNavigate, useParams, Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import CustomPagination from '../../../components/company_panel/common/custompagination'
import Sorting from '../../../components/company_panel/common/sorting';
import Loader from '../../../components/company_panel/common/loader'
import $ from "jquery";
import { capitalizeAllFirstLetters, capitalizeFirstLetter, checkPermission, formateDate, getBrandId, getCompany, removeHyphens } from '../../../helpers/commonFunctions';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfigurationTab from '../configurationTab';
import * as yup from 'yup';
import { ChangeMenuItemsStatus, DeleteMenuItems, ExportMenuItemRecipes, ExportMenuItems, ExportMenuItemsPricing, GetMenuItemsList, ImportedMenuItems, ImportMenuItemsPricing, UpdateMenuItemRecipes } from '../../../services/company_panel/menuItems';
import { getParentCategories, GetAllChildCategories } from '../../../services/company_panel/menuCategoryService';
import CustomRangepicker from '../../../components/company_panel/common/rangepicker';
import StatusFilter from '../../../components/company_panel/common/statusFilter';
import { showFilterlist } from '../../../utils/Constants';
import notFound from '../../../assets/company/img/no-record-found.png'
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import SampleFileXlsx from '../../../assets/company/menuItemSampleFiles/MenuItemsSample.xlsx';
import SampleFileXls from '../../../assets/company/menuItemSampleFiles/MenuItemsSampleFile.xls';
import SampleFileCsv from '../../../assets/company/menuItemSampleFiles/MenuItemsSample.csv';
import GlobalLoader from '../../../components/company_panel/common/globalLoader';
import { usePersistedListState } from '../../../hooks/usePersistedListState';


const MenuItemList = () => {
    const breadcrumbs = [{ title: "Dashboard", url: "/company/dashboard" }, { title: "Pages", url: "" },]
    const navigate = useNavigate()
    const location = useLocation()
    const routeParams = useParams()
    // persisted filters (page lives in the route/query) — restored on return from add/edit/view
    const { saved, save, clear } = usePersistedListState('menu_items');
    const [list, setList] = useState([])
    const [statsUpdate, setStatusUpdate] = useState("false")
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(saved?.itemPerPage || 10)
    const [sorting, setSorting] = useState(saved?.sorting || {});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(Number(routeParams?.id) || 1);
    const [loader, setLoader] = useState(true)
    const [globalLoader, setGlobalLoader] = useState(false);
    const [search, setSearch] = useState(saved?.search || {})
    const [globalSearch, setGlobalSearch] = useState(saved?.globalSearch || "")
    const [resetdate, setResetDate] = useState(false);
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [exportData, setExportData] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [subCategoryList, setSubCategoryList] = useState([]);

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
    });

    useEffect(() => {
        if (search) {
            setLoader(true)
            const formData = new FormData()
            formData.append("page", page)
            formData.append("per_page", itemPerPage)
            formData.append("sort", JSON.stringify(sorting))
            formData.append("search", JSON.stringify(search))
            formData.append("global_search", globalSearch)
            formData.append('brand_id', getBrandId());
            GetMenuItemsList(formData).then(data => {
                setDataLength(data.data.response.count);
                setList(data && data.data && data.data.response ? data.data.response.rows : [])
                setLoader(false)
            }).catch(error => {
                setLoader(false)
                console.log("error ====> ", error);
            })
        }

    }, [location, statsUpdate, sorting, search, globalSearch, isBrandChanged])

    // persist filters on every change (page lives in the route/query, not the store)
    useEffect(() => {
        save({ itemPerPage, sorting, search, globalSearch });
    }, [itemPerPage, sorting, search, globalSearch])

    useEffect(() => {
        const formData = new FormData();
        formData.append('brand_id', getBrandId());
        getParentCategories(formData).then(data => {
            setCategoryList(data?.data?.response?.rows || []);
        }).catch(error => {
            console.log("parent categories error ====> ", error);
        })
        setSubCategoryList([]);
    }, [isBrandChanged])

    const handleCategoryFilter = (categoryId) => {
        setSearch(prev => {
            const next = { ...prev };
            delete next.sub_category_id;
            if (categoryId) next.category_id = categoryId;
            else delete next.category_id;
            return next;
        });
        setSubCategoryList([]);
        if (!categoryId) return;
        const formData = new FormData();
        formData.append('category_id', categoryId);
        formData.append('brand_id', getBrandId());
        GetAllChildCategories(formData).then(data => {
            setSubCategoryList(data?.data?.response?.rows || []);
        }).catch(error => {
            console.log("child categories error ====> ", error);
        })
    }

    // useEffect(() => {
    //         setLoader(true)
    //         const formData = new FormData()
    //         formData.append("page", page)
    //         formData.append("per_page", itemPerPage)
    //         formData.append('brand_id', getBrandId());
    //         ExportMenuItems(formData).then(data => {
    //             // setDataLength(data.data.response.count);
    //             setUoms(data && data.data && data.data.response ? data.data.response.uoms : []);
    //             setExportData(data && data.data && data.data.response ? data.data.response.rows : [])
    //             setLoader(false)
    //         }).catch(error => {
    //             console.log("error ====> ", error);
    //         })
    // }, [isBrandChanged])


    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        setResetDate(!resetdate)
        setSubCategoryList([])
        clear()
        $("#defaultstatus").prop("selectedIndex", 0)
    }

    function deleteFunction(row) {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const formdata = new FormData()
                formdata.append("id", row)
                DeleteMenuItems(formdata).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: data.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("deleteError",error)
                })
            }
        })
    }

    const ChangeStatus = (row, Num) => {
        const formData = new FormData()
        formData.append("id", row)
        formData.append("status", Num)
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f9bff',
            cancelButtonColor: '#dc3545',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                ChangeMenuItemsStatus(formData).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'success',
                            title: data.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("error===>",error)
                })
            }
        })
    }

    const handleEdit = (id) => {
        navigate(`/company/menu/menu/menu_items/edit/${id}?pageno=${page}`);
    }
    const copyOutletFunction = (row) => {
        navigate(`/company/menu/menu/menu_items/edit/${row.id}?copy=true&pageno=${page}`);
    }
    const handleView = (id) => {
        navigate(`/company/menu/menu/menu_items/view/${id}?pageno=${page}`);
    }

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }

    const formatDefaultPrices = (defaultPrices) => {
        if (!defaultPrices || defaultPrices.length === 0) return 'N/A';
        return defaultPrices.map(price => `${price.name}: ${price.price}`).join('; ');
    };

    // const handleExport = () => {
    //     const printData = exportData.map((item) => {
    //         const transformedItem = {};
    //         const PrimaryCategoryName = item?.menu_category?.menu_category?.name ? capitalizeFirstLetter(item?.menu_category?.menu_category?.name) : 'N/A';
    //         const secondaryCategoryName = item?.menu_category && item?.menu_category ? capitalizeFirstLetter(item.menu_category?.name) : 'N/A';
    //         const defaultPrices = item?.menu_item_outlet_default_prices ? formatDefaultPrices(item.menu_item_outlet_default_prices) : 'N/A';
    
    //         for (const key in headerMapping) {
    //             if (headerMapping.hasOwnProperty(key)) {
    //                 const newKey = headerMapping[key];
    //                 if (key === "menu_category") {
    //                     transformedItem[newKey] = PrimaryCategoryName;
    //                 } else if (key === "menu_secondary_category") {
    //                     transformedItem[newKey] = secondaryCategoryName;
    //                 } else if (key === "pricing_type") {
    //                     transformedItem[newKey] = formatValue(removeHyphens(capitalizeFirstLetter(item?.pricing_type)));
    //                 } else if (key === "menu_item_outlet_default_prices") {
    //                     transformedItem[newKey] = defaultPrices;
    //                 } else {
    //                     transformedItem[newKey] = formatValue(item[key]);
    //                 }
    //             }
    //         }
    //         return transformedItem;
    //     });
    //     const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    //     const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    //     const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    //     saveAs(blob, 'menu-items.xlsx');
    // };

    const headerMapping = {
        "id": "Item Id",
        "item_name": "Name",
        "item_name_ar": "Name Arabic",
        "menu_category": "Primary Category",
        "menu_secondary_category": "Secondary Category",
        "sku": "SKU",
        "calories":"Calories",
        "default_price":"Default Price",
        "pricing_type": "Pricing Type",
        "tax_configuration" : "Tax Group",
        "updates_type": "Update Type",
        "short_description": "Description",
        "short_description_ar": "Description Arabic",
        "status": "Status",
        "created_at": "Created At",
        "menu_item_outlet_default_prices" : "Default Outlet Prices",
        "menu_item_outlet_specific_prices" : "Specific Outlet Prices",
        "menu_item_add_ons": "Menu Items Addon",
        "addon_outlet_default_prices" : "Addons Default Outlet Prices",
        "addon_outlet_specific_prices" : "Addons Specific Outlet Prices",
    };

    const formatValue = (value) => {
        if (value === null || value === undefined || value === "") {
            return 'N/A';
        }
        return value.toString().replace(/_/g, ' ');
    };
  

    const handleExport = () => {
        setGlobalLoader(true);
        const formData = new FormData()
        formData.append("page",1)
        formData.append("per_page", dataLength || itemPerPage)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('brand_id', getBrandId());

        ExportMenuItems(formData).then(data => {
            const exportRows = data && data.data && data.data.response ? data.data.response.rows : [];

            const menuItemsData  = []
            const defaultPricesData = []
            const specificPricesData = []
            const addOnData = [];
            const addOnMerges = [];
            let addOnRowIndex = 1; // row 0 is the header
            const addonDefaultPricesData = []
            const addonSpecificPricesData = []

            exportRows.forEach((item) => {

                //preparing menuItemsSheet
                const transformedItem = {};
                const PrimaryCategoryName = item?.menu_category?.menu_category?.name ? capitalizeFirstLetter(item?.menu_category?.menu_category?.name) : 'N/A';
                const secondaryCategoryName = item?.menu_category && item?.menu_category ? capitalizeFirstLetter(item.menu_category?.name) : 'N/A';
                const tax_configuration = item?.tax_configuration && item?.tax_configuration ? capitalizeFirstLetter(item.tax_configuration?.name) : 'N/A';
                for (const key in headerMapping) {
                    if (headerMapping.hasOwnProperty(key)) {
                        const newKey = headerMapping[key];
                        if (key === "menu_category") {
                            transformedItem[newKey] = PrimaryCategoryName;
                        } else if (key === "menu_secondary_category") {
                            transformedItem[newKey] = secondaryCategoryName;
                        } else if (key === "pricing_type") {
                            transformedItem[newKey] = formatValue(removeHyphens(capitalizeFirstLetter(item?.pricing_type)));
                        } 
                        else if (key === "tax_configuration") {
                            transformedItem[newKey] = (tax_configuration);
                        }
                        else if (key === "menu_item_outlet_default_prices") {
                            transformedItem[newKey] = 'See separate sheet';
                        } 
                        else if (key === "menu_item_outlet_specific_prices") {
                            transformedItem[newKey] = 'See separate sheet';
                        }
                        else if (key === "menu_item_add_ons") {
                            transformedItem[newKey] = 'See separate sheet';
                        }
                        else if (key === "addon_outlet_default_prices") {
                            transformedItem[newKey] = 'See separate sheet';
                        } 
                        else if (key === "addon_outlet_specific_prices") {
                            transformedItem[newKey] = 'See separate sheet';
                        }
                        else if (key === "created_at") {
                            transformedItem[newKey] = formateDate(item.created_at);
                        }
                        else {
                            transformedItem[newKey] = formatValue(item[key]);
                        }
                    }
                }
                menuItemsData.push(transformedItem);

                //preapring defaultPricesSheet
                (Array.isArray(item.menu_item_outlet_default_prices) ? item.menu_item_outlet_default_prices : []).forEach(price => defaultPricesData.push({
                    "Item Id": item?.id,
                    'Menu Item Name': item?.item_name,
                    'Price Type': price.order_mode_id ? 'Order Mode' : 'Aggregator',
                    'Order Mode / Aggregator Name': price.name,
                    'Price': (price.price + " " +  "SAR")
                }));

                //preparing specificOutletPricesSheet
                (Array.isArray(item.menu_item_outlet_specific_prices) ? item.menu_item_outlet_specific_prices : []).forEach(price => specificPricesData.push({
                    "Item Id": item?.id,
                    'Menu Item Name': item?.item_name,
                    'Outlets': (Array.isArray(price?.outlets) ? price.outlets.map(outlet => (`${outlet.name} (${outlet.short_code})`)) : []).join(',  '),
                    'Price Type': price.order_mode_id ? 'Order Mode' : 'Aggregator',
                    'Order Mode / Aggregator Name': price.name || 'N/A',
                    'Price': price.price ? (price.price  + " " +  "SAR") : 'N/A',
                }));

                //preparing addonsCategorySheet
                const menuItemName = item?.item_name || 'N/A';
                (Array.isArray(item.menu_item_add_ons) ? item.menu_item_add_ons : []).forEach(addOn => {
                    const addons = (Array.isArray(addOn.add_ons) && addOn.add_ons.length) ? addOn.add_ons : [];
                    const startRow = addOnRowIndex;
                    addons.forEach(addon => {
                        addOnData.push({
                            "Item Id": item?.id,
                            'Menu Item Name': menuItemName,
                            'Add-On Category Id': addOn.add_on_category_id,
                            'Add-On Category': capitalizeFirstLetter(removeHyphens(addOn.add_on_category_name || 'N/A')),
                            'Min': addOn.min || 'N/A',
                            'Max': addOn.max || 'N/A',
                            'Free': addOn.free || 'N/A',
                            'Addon Id': addon?.id ?? 'N/A',
                            'Addon Name': addon?.name || 'N/A'
                        });
                        addOnRowIndex++;

                        //preparing addonsDefaultPricesSheet
                        (Array.isArray(addon.addon_outlet_default_prices) ? addon.addon_outlet_default_prices : []).forEach(addonDefaultPrice=>{
                            addonDefaultPricesData.push({
                                "Item Id": item?.id,
                                'Menu Item Name': menuItemName,
                                'Add-On Category Id': addOn.add_on_category_id,
                                'Add-On Category': capitalizeFirstLetter(removeHyphens(addOn.add_on_category_name || 'N/A')),
                                'Min': addOn.min || 'N/A',
                                'Max': addOn.max || 'N/A',
                                'Free': addOn.free || 'N/A',
                                'Addon Id': addon?.id ?? 'N/A',
                                'Addon Name': addon?.name || 'N/A',
                                'Price Type': addonDefaultPrice.order_mode_id ? 'Order Mode' : 'Aggregator',
                                'Order Mode / Aggregator Name': addonDefaultPrice.name,
                                'Price': (addonDefaultPrice.price + " " +  "SAR")
                            })
                        });

                        //preparing addonsSpecificPricesSheet
                        (Array.isArray(addon.addon_outlet_specific_prices) ? addon.addon_outlet_specific_prices : []).forEach(addonSpecificPrice=>{
                            addonSpecificPricesData.push({
                                "Item Id": item?.id,
                                'Menu Item Name': menuItemName,
                                'Add-On Category Id': addOn.add_on_category_id,
                                'Add-On Category': capitalizeFirstLetter(removeHyphens(addOn.add_on_category_name || 'N/A')),
                                'Min': addOn.min || 'N/A',
                                'Max': addOn.max || 'N/A',
                                'Free': addOn.free || 'N/A',
                                'Addon Id': addon?.id ?? 'N/A',
                                'Addon Name': addon?.name || 'N/A',
                                'Price Type': addonSpecificPrice.order_mode_id ? 'Order Mode' : 'Aggregator',
                                'Order Mode / Aggregator Name': addonSpecificPrice.name || 'N/A',
                                'Price': addonSpecificPrice.price ? (addonSpecificPrice.price  + " " +  "SAR") : 'N/A',
                                'Outlets': (Array.isArray(addonSpecificPrice?.outlets) ? addonSpecificPrice.outlets.map(outlet => (`${outlet.name} (${outlet.short_code})`)) : []).join(',  '),
                            })
                        })
                    });
                    const endRow = addOnRowIndex - 1;
                    if (endRow > startRow) {
                        // row-span the shared columns (Item Id .. Free => cols 0-6) across this addon group
                        for (let c = 0; c <= 6; c++) {
                            addOnMerges.push({ s: { r: startRow, c }, e: { r: endRow, c } });
                        }
                    }
                });
            });

    
        
            // Auto-fit column widths from header + cell content (clamped to a sensible range).
            const autoCols = (rows, headers) => {
                const keys = headers || (rows[0] ? Object.keys(rows[0]) : []);
                return keys.map(key => {
                    let max = String(key).length;
                    rows.forEach(r => {
                        const len = r[key] == null ? 0 : String(r[key]).length;
                        if (len > max) max = len;
                    });
                    return { wch: Math.min(Math.max(max + 2, 10), 60) };
                });
            };

            const menuItemsHeader = Object.values(headerMapping);
            const pricesHeader = ["Item Id", 'Menu Item Name', 'Price Type', 'Order Mode / Aggregator Name', 'Price'];
            const addOnHeader = ["Item Id", 'Menu Item Name', 'Add-On Category Id', 'Add-On Category', 'Min', 'Max', 'Free', 'Addon Id', 'Addon Name'];

            const ws1 = XLSX.utils.json_to_sheet(menuItemsData, { header: menuItemsHeader });
            ws1['!cols'] = autoCols(menuItemsData, menuItemsHeader);
            const ws2 = XLSX.utils.json_to_sheet(defaultPricesData, { header: pricesHeader });
            ws2['!cols'] = autoCols(defaultPricesData, pricesHeader);
            const ws3 = XLSX.utils.json_to_sheet(specificPricesData, { header: pricesHeader });
            ws3['!cols'] = autoCols(specificPricesData, pricesHeader);
            const ws4 = XLSX.utils.json_to_sheet(addOnData, { header: addOnHeader });
            ws4['!cols'] = autoCols(addOnData, addOnHeader);
            ws4['!merges'] = addOnMerges;
            const ws5 = XLSX.utils.json_to_sheet(addonDefaultPricesData);
            ws5['!cols'] = autoCols(addonDefaultPricesData);
            const ws6 = XLSX.utils.json_to_sheet(addonSpecificPricesData);
            ws6['!cols'] = autoCols(addonSpecificPricesData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws1, 'Menu Items');
            XLSX.utils.book_append_sheet(wb, ws2, 'Default Outlet Prices');
            XLSX.utils.book_append_sheet(wb, ws3, 'Specific Outlet Prices');
            XLSX.utils.book_append_sheet(wb, ws4, 'Menu Items Addons');
            XLSX.utils.book_append_sheet(wb, ws5, 'Addons Default Outlet Prices');
            XLSX.utils.book_append_sheet(wb, ws6, 'Addons Specific Outlet Prices');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, 'menu-items.xlsx');
            setGlobalLoader(false);
        }).catch(error => {
            console.log("error ====> ", error);
            setGlobalLoader(false);
        })
    };
    

    const fileInputRef = useRef(null);

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    // ---- Import recipes -----------------------------------------------------
    // The sheet is parsed here, not on the server: the four columns below are
    // required, order mode skus arrive comma separated in one cell, and the rows
    // only leave the browser once every one of them is valid.
    const RECIPE_COLUMNS = [
        { field: 'menu_item_id', label: 'menu item id', header: 'Menu Item ID', sample: 85 },
        { field: 'recipe_sku', label: 'recipe sku', header: 'Recipe SKU', sample: 'QKV503BS' },
        { field: 'quantity', label: 'quantity', header: 'Quantity', sample: 2 },
        { field: 'order_mode_short_codes', label: 'order mode short code', header: 'Order Mode Short Code', sample: 'DNIN, TKOUT' },
    ];

    // Headers are matched on the exact wording, case and spacing aside: "Menu
    // Item ID" and "menu item id" both pass, "menu_item_id" does not.
    const normalizeHeader = (header) => String(header || '').trim().toLowerCase().replace(/\s+/g, ' ');

    // Built from RECIPE_COLUMNS rather than shipped as a static file, so the
    // sample always carries exactly the columns the import expects.
    // The template comes back filled with the brand's current recipes, so a bulk
    // change is an edit of what is already there rather than a sheet typed from
    // scratch. Columns stay exactly the ones the import matches on.
    const downloadRecipeSample = () => {
        const buildWorkbook = async (recipeList, orderModes) => {
            const recipeRows = recipeList.map(recipe => ([
                recipe?.item_id ?? '',
                recipe?.recipe_sku || '',
                // A real number so the column can be edited as a quantity.
                isNaN(Number(recipe?.quantity)) ? recipe?.quantity : Number(recipe?.quantity),
                (recipe?.order_mode_short_codes || []).join(', '),
            ]));
            const workbook = new ExcelJS.Workbook();
            const recipesSheet = workbook.addWorksheet('Recipes');
            recipesSheet.columns = RECIPE_COLUMNS.map((column, index) => ({ header: column.header, width: [16, 22, 12, 60][index] }));
            // Nothing to edit yet: show the example row so the format is still clear.
            recipesSheet.addRows(recipeRows.length ? recipeRows : [RECIPE_COLUMNS.map(column => column.sample)]);
            recipesSheet.getRow(1).font = { bold: true };
            // only quantity and the short codes are typed in; the id and sku say which recipe line a row is
            [3, 4].forEach(columnNumber => recipesSheet.getColumn(columnNumber).eachCell((cell, rowNumber) => {
                if (rowNumber > 1) cell.protection = { locked: false };
            }));
            await recipesSheet.protect('', { selectLockedCells: true, selectUnlockedCells: true, sort: true, autoFilter: true, formatColumns: true, formatRows: true });

            // Second sheet so whoever fills the template can read the brand's
            // short codes straight off it instead of hunting for them. Read only.
            const codesSheet = workbook.addWorksheet('order-mode-short-codes');
            codesSheet.columns = [{ header: 'Order Mode Name', width: 30 }, { header: 'Short Code', width: 18 }];
            codesSheet.addRows(orderModes.map(orderMode => ([
                orderMode?.name ? capitalizeAllFirstLetters(orderMode.name) : '-',
                orderMode?.short_code || '-',
            ])));
            codesSheet.getRow(1).font = { bold: true };
            await codesSheet.protect('', { selectLockedCells: true, selectUnlockedCells: true, sort: true, autoFilter: true, formatColumns: true, formatRows: true });

            const excelBuffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), 'update-menu-item-bulk-recipes-sample.xlsx');
        };

        setGlobalLoader(true);
        // The same filters the listing is showing, so the template covers exactly
        // the menu items on screen rather than the whole brand.
        ExportMenuItemRecipes({
            brand_id: getBrandId(),
            sort: JSON.stringify(sorting),
            search: JSON.stringify(search),
            global_search: globalSearch,
        }).then(data => {
            const response = data?.data?.response || {};
            return buildWorkbook(response.recipe_list || [], response.order_modes || []);
        }).catch(error => {
            console.log("Error---->", error);
            // The template still downloads; only the data is missing.
            const download = buildWorkbook([], []);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: error?.response?.data?.message || 'Could not load the existing recipes',
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
            });
            return download;
        }).finally(() => {
            setGlobalLoader(false);
        });
    };

    const recipeFileInputRef = useRef(null);

    const triggerRecipeFileInput = () => {
        if (recipeFileInputRef.current) {
            recipeFileInputRef.current.click();
        }
    };

    const showRecipeError = (html) => {
        Swal.fire({
            customClass: 'swal-wide',
            icon: 'error',
            title: 'Invalid file',
            html,
            confirmButtonColor: '#2f9bff',
        });
    };

    const handleRecipeFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (event) => {
            e.target.value = null;
            let sheetRows = [];
            let headers = [];
            try {
                const workbook = XLSX.read(new Uint8Array(event.target.result), { type: 'array' });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                // header:1 first, so the header row can be checked before the rows are mapped.
                const raw = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '', blankrows: false });
                headers = raw[0] || [];
                sheetRows = XLSX.utils.sheet_to_json(sheet, { defval: '', blankrows: false });
            } catch (error) {
                console.log("Error---->", error);
                showRecipeError('This file could not be read. Please upload a valid xls or xlsx file.');
                return;
            }

            // Every required column has to be there, whatever the casing.
            const headerMap = {};
            const missing = [];
            RECIPE_COLUMNS.forEach(column => {
                const match = headers.find(header => normalizeHeader(header) === column.label);
                if (match === undefined) missing.push(column.label);
                else headerMap[column.field] = match;
            });
            if (missing.length) {
                showRecipeError(`These column(s) are missing: <b>${missing.join(', ')}</b>`);
                return;
            }
            if (!sheetRows.length) {
                showRecipeError('This file has no rows to import.');
                return;
            }

            const errors = [];
            const recipes = [];
            sheetRows.forEach((sheetRow, index) => {
                // +2: the header is row 1, so the first data row is row 2 in the sheet.
                const rowNumber = index + 2;
                const menuItemId = String(sheetRow[headerMap.menu_item_id] ?? '').trim();
                const recipeSku = String(sheetRow[headerMap.recipe_sku] ?? '').trim();
                const quantity = String(sheetRow[headerMap.quantity] ?? '').trim();
                // Short codes on the order mode, comma separated in one cell.
                const orderModeShortCodes = String(sheetRow[headerMap.order_mode_short_codes] ?? '')
                    .split(',').map(code => code.trim()).filter(Boolean);

                if (!menuItemId || isNaN(Number(menuItemId))) errors.push(`Row ${rowNumber}: menu item id must be a number`);
                if (!recipeSku) errors.push(`Row ${rowNumber}: recipe sku is required`);
                if (!quantity || isNaN(Number(quantity)) || Number(quantity) <= 0) errors.push(`Row ${rowNumber}: quantity must be a number greater than 0`);
                if (!orderModeShortCodes.length) errors.push(`Row ${rowNumber}: at least one order mode short code is required`);

                recipes.push({
                    menu_item_id: Number(menuItemId),
                    recipe_sku: recipeSku,
                    quantity: Number(quantity),
                    order_mode_short_codes: orderModeShortCodes,
                });
            });

            if (errors.length) {
                const shown = errors.slice(0, 10).join('<br/>');
                const more = errors.length > 10 ? `<br/><b>and ${errors.length - 10} more</b>` : '';
                showRecipeError(`${shown}${more}`);
                return;
            }

            setGlobalLoader(true);
            UpdateMenuItemRecipes({
                brand_id: getBrandId(),
                recipes: JSON.stringify(recipes),
            }).then(response => {
                const success = response.data.status === 1 || response.data.status === '1';
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: success ? 'success' : 'error',
                    title: response.data.message,
                    showConfirmButton: false,
                    // The import reports what it did, so give it time to be read.
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
                if (success) setStatusUpdate(!statsUpdate);
            }).catch(error => {
                console.log("Error---->", error);
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: error?.response?.data?.message || 'Could not import recipes',
                    showConfirmButton: false,
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
            }).finally(() => {
                setGlobalLoader(false);
            });
        };
        reader.readAsArrayBuffer(file);
    };

    // ---- Pricing sample -------------------------------------------------------
    // One workbook, one tab per kind of price: the menu item's own price, its
    // default prices and its outlet specific prices, for the menu items the list
    // is showing. Prices are written as real numbers so the sheet can be edited.
    const downloadPricingSample = () => {
        setGlobalLoader(true);
        const formData = new FormData()
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('brand_id', getBrandId());
        ExportMenuItemsPricing(formData).then(async data => {
            const rows = data?.data?.response?.rows || [];
            if (!rows.length) {
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: 'There are no menu item prices to export',
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                    position: 'top-right',
                });
                return;
            }

            const toPrice = (value) => (value == null || value === '' ? 'N/A' : (isNaN(Number(value)) ? value : Number(value)));

            const pricesData = [];
            const defaultPricesData = [];
            const specificPricesData = [];

            rows.forEach(menuItem => {
                const menuItemId = menuItem?.id ?? 'N/A';
                const menuItemName = menuItem?.name ? capitalizeFirstLetter(menuItem.name) : 'N/A';

                pricesData.push({
                    'Menu Item ID': menuItemId,
                    'Menu Item Name': menuItemName,
                    'Price': toPrice(menuItem?.price),
                });

                (menuItem?.menu_item_outlet_default_prices || []).forEach(price => defaultPricesData.push({
                    'Menu Item ID': menuItemId,
                    'Menu Item Name': menuItemName,
                    'Type': price?.order_mode_id ? 'Order Mode' : 'Aggregator',
                    'Order Mode / Aggregator ID': price?.order_mode_id ?? price?.aggregator_id ?? '',
                    'Order Mode / Aggregator Name': price?.name || 'N/A',
                    'Price': toPrice(price?.price),
                }));

                (menuItem?.menu_item_outlet_specific_prices || []).forEach(price => specificPricesData.push({
                    'Menu Item ID': menuItemId,
                    'Menu Item Name': menuItemName,
                    'Type': price?.order_mode_id ? 'Order Mode' : 'Aggregator',
                    'Order Mode / Aggregator ID': price?.order_mode_id ?? price?.aggregator_id ?? '',
                    'Order Mode / Aggregator Name': price?.name || 'N/A',
                    'Price': toPrice(price?.price),
                    'Outlet Short Codes': (price?.outlets || []).map(outlet => outlet?.short_code).filter(Boolean).join(', ') || 'N/A',
                }));
            });

            // Column widths from header + content, clamped.
            const autoCols = (sheetRows, headers) => headers.map(key => {
                let max = String(key).length;
                sheetRows.forEach(row => {
                    const length = row[key] == null ? 0 : String(row[key]).length;
                    if (length > max) max = length;
                });
                return { wch: Math.min(Math.max(max + 2, 10), 60) };
            });

            const sheets = [
                { name: 'Prices', rows: pricesData, header: ['Menu Item ID', 'Menu Item Name', 'Price'] },
                { name: 'Default Prices', rows: defaultPricesData, header: ['Menu Item ID', 'Menu Item Name', 'Type', 'Order Mode / Aggregator ID', 'Order Mode / Aggregator Name', 'Price'] },
                { name: 'Specific Prices', rows: specificPricesData, header: ['Menu Item ID', 'Menu Item Name', 'Type', 'Order Mode / Aggregator ID', 'Order Mode / Aggregator Name', 'Price', 'Outlet Short Codes'] },
            ];
            // ExcelJS so the price cells can be left editable while the rest of each sheet is locked
            const workbook = new ExcelJS.Workbook();
            for (const sheet of sheets) {
                const widths = autoCols(sheet.rows, sheet.header);
                const worksheet = workbook.addWorksheet(sheet.name);
                worksheet.columns = sheet.header.map((header, index) => ({ header, key: header, width: widths[index].wch }));
                worksheet.addRows(sheet.rows);
                worksheet.getRow(1).font = { bold: true };
                worksheet.getColumn('Price').eachCell((cell, rowNumber) => {
                    if (rowNumber > 1) cell.protection = { locked: false };
                });
                // sorting, filtering and resizing stay allowed; only the cell values are protected
                await worksheet.protect('', { selectLockedCells: true, selectUnlockedCells: true, sort: true, autoFilter: true, formatColumns: true, formatRows: true });
            }
            const excelBuffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), 'menu-items-pricing.xlsx');
        }).catch(error => {
            console.log("error ====> ", error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: error?.response?.data?.message || 'Could not export menu item pricing',
                showConfirmButton: false,
                timer: 5000,
                toast: true,
                position: 'top-right',
            });
        }).finally(() => {
            setGlobalLoader(false);
        });
    };

    // ---- Pricing import -------------------------------------------------------
    // The pricing sheet, edited and uploaded back. Each tab is read by its name and
    // sent as its own array: prices of { id, price }; default and specific prices of
    // { id, aggregator_id, order_mode_id, price }, specific prices also carrying
    // outlet_short_codes [] from the comma separated Outlet Short Codes column. Type
    // decides whether the id column is an order mode or an aggregator.
    const PRICING_SHEETS = [
        {
            key: 'prices',
            name: 'Prices',
            columns: [
                { field: 'menu_item_id', label: 'menu item id', header: 'Menu Item ID' },
                { field: 'price', label: 'price', header: 'Price' },
            ],
        },
        {
            key: 'default_prices',
            name: 'Default Prices',
            columns: [
                { field: 'menu_item_id', label: 'menu item id', header: 'Menu Item ID' },
                { field: 'type', label: 'type', header: 'Type' },
                { field: 'price_id', label: 'order mode / aggregator id', header: 'Order Mode / Aggregator ID' },
                { field: 'price', label: 'price', header: 'Price' },
            ],
        },
        {
            key: 'specific_prices',
            name: 'Specific Prices',
            columns: [
                { field: 'menu_item_id', label: 'menu item id', header: 'Menu Item ID' },
                { field: 'type', label: 'type', header: 'Type' },
                { field: 'price_id', label: 'order mode / aggregator id', header: 'Order Mode / Aggregator ID' },
                { field: 'price', label: 'price', header: 'Price' },
                { field: 'outlet_short_codes', label: 'outlet short codes', header: 'Outlet Short Codes' },
            ],
        },
    ];
    const pricingFileInputRef = useRef(null);

    const triggerPricingFileInput = () => {
        if (pricingFileInputRef.current) {
            pricingFileInputRef.current.click();
        }
    };

    const handlePricingFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (event) => {
            e.target.value = null;
            let workbook;
            try {
                workbook = XLSX.read(new Uint8Array(event.target.result), { type: 'array' });
            } catch (error) {
                console.log("Error---->", error);
                showRecipeError('This file could not be read. Please upload a valid xls or xlsx file.');
                return;
            }

            const missingSheets = PRICING_SHEETS.filter(pricingSheet => !workbook.Sheets[pricingSheet.name]).map(pricingSheet => pricingSheet.name);
            if (missingSheets.length) {
                showRecipeError(`These sheet(s) are missing: <b>${missingSheets.join(', ')}</b>`);
                return;
            }

            const errors = [];
            const pricing = {};
            PRICING_SHEETS.forEach(pricingSheet => {
                const sheet = workbook.Sheets[pricingSheet.name];
                // Header row first, so the columns are checked before any row is read.
                const headers = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '', blankrows: false })[0] || [];
                const sheetRows = XLSX.utils.sheet_to_json(sheet, { defval: '', blankrows: false });

                const headerMap = {};
                const missing = [];
                pricingSheet.columns.forEach(column => {
                    const match = headers.find(header => normalizeHeader(header) === column.label);
                    if (match === undefined) missing.push(column.header);
                    else headerMap[column.field] = match;
                });
                pricing[pricingSheet.key] = [];
                if (missing.length) {
                    errors.push(`${pricingSheet.name}: these column(s) are missing: <b>${missing.join(', ')}</b>`);
                    return;
                }

                sheetRows.forEach((sheetRow, index) => {
                    // +2: the header is row 1, so the first data row is row 2 in the sheet.
                    const row = `${pricingSheet.name} row ${index + 2}`;
                    const cell = (field) => String(sheetRow[headerMap[field]] ?? '').trim();

                    const menuItemId = cell('menu_item_id');
                    // the sample file writes N/A where a price isn't set
                    const price = cell('price').toLowerCase() === 'n/a' ? '' : cell('price');
                    if (!menuItemId || !Number.isInteger(Number(menuItemId)) || Number(menuItemId) <= 0) errors.push(`${row}: menu item id must be a whole number greater than 0`);
                    if (price && (!Number.isFinite(Number(price)) || Number(price) < 0)) errors.push(`${row}: price must be a number of 0 or more`);

                    if (pricingSheet.key === 'prices') {
                        pricing.prices.push({ id: Number(menuItemId), price: price === '' ? '' : Number(price) });
                        return;
                    }

                    const type = normalizeHeader(cell('type'));
                    const priceId = cell('price_id');
                    if (type !== 'order mode' && type !== 'aggregator') errors.push(`${row}: type must be Order Mode or Aggregator`);
                    if (!priceId || !Number.isInteger(Number(priceId)) || Number(priceId) <= 0) errors.push(`${row}: order mode / aggregator id must be a whole number greater than 0`);

                    pricing[pricingSheet.key].push({
                        id: Number(menuItemId),
                        aggregator_id: type === 'aggregator' ? Number(priceId) : null,
                        order_mode_id: type === 'order mode' ? Number(priceId) : null,
                        // the sample file writes N/A where a group has no outlets
                        ...(pricingSheet.key === 'specific_prices' && {
                            outlet_short_codes: cell('outlet_short_codes').toLowerCase() === 'n/a' ? [] : [...new Set(cell('outlet_short_codes').split(',').map(code => code.trim()).filter(Boolean))],
                        }),
                        price: price === '' ? '' : Number(price),
                    });
                });
            });

            if (errors.length) {
                const shown = errors.slice(0, 10).join('<br/>');
                const more = errors.length > 10 ? `<br/><b>and ${errors.length - 10} more</b>` : '';
                showRecipeError(`${shown}${more}`);
                return;
            }
            if (!pricing.prices.length && !pricing.default_prices.length && !pricing.specific_prices.length) {
                showRecipeError('This file has no rows to import.');
                return;
            }

            setGlobalLoader(true);
            ImportMenuItemsPricing({
                brand_id: getBrandId(),
                prices: JSON.stringify(pricing.prices),
                default_prices: JSON.stringify(pricing.default_prices),
                specific_prices: JSON.stringify(pricing.specific_prices),
            }).then(response => {
                const success = response.data.status === 1 || response.data.status === '1';
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: success ? 'success' : 'error',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
                if (success) setStatusUpdate(!statsUpdate);
            }).catch(error => {
                console.log("Error---->", error);
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: error?.response?.data?.message || 'Could not import menu item pricing',
                    showConfirmButton: false,
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                });
            }).finally(() => {
                setGlobalLoader(false);
            });
        };
        reader.readAsArrayBuffer(file);
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append("file", file);
        formData.append("brand_id", localStorage.getItem("brand_id"))
        ImportedMenuItems(formData).then((response) => {
            setStatusUpdate(!statsUpdate);
            e.target.value = null;
            if (response.data.status === 1 || response.data.status === '1') {
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000,
                    toast: true,
                    position: 'top-right',
                })
            }
            else if (response.data.status === 0 || response.data.status === '0') {
                Swal.fire({
                    customClass: 'swal-wide',
                    icon: 'error',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 5000,
                    toast: true,
                    position: 'top-right',
                })
            }
        }).catch((error) => {
            console.log("Error---->", error);
        })
    }

    return (
        <>
            {globalLoader && <GlobalLoader />}
            <div className="animation_fade">
                <div className='page-header d-flex align-items-left'>
                    <div className='page-header-left'>
                        <h4>Menu</h4>
                    </div>
                    <div className='page-header-right ms-auto'>
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                        <div className='col-12'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <ConfigurationTab tab='menuItem' />
                            </div>
                        </div>
                    </div>
                    <div className="gap-20">
                        <div className='page-header d-flex flex-wrap align-items-center mb-0' style={{ rowGap: '12px' }}>
                            <div className='page-header-left' style={{ flex: '1 1 auto', minWidth: 0 }}>
                                <div className='gap-2'>
                                    <div className='filter-header d-flex flex-wrap align-items-center' style={{ gap: '12px' }}>
                                        <div className="form-group mb-0 rangepicker_container">
                                            <input
                                                type="search"
                                                className="form-control"
                                                value={globalSearch}
                                                placeholder="Search"
                                                onChange={(e) => { setGlobalSearch(e.target.value) }}
                                            />
                                        </div>
                                        <select
                                            className='form-control'
                                            value={search.category_id || ''}
                                            onChange={(e) => handleCategoryFilter(e.target.value)}
                                            style={{ width: '180px' }}
                                        >
                                            <option value=''>All Categories</option>
                                            {categoryList.map((cat) => (
                                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                                            ))}
                                        </select>
                                        <select
                                            className='form-control'
                                            value={search.sub_category_id || ''}
                                            onChange={(e) => prepareSearch('sub_category_id', e.target.value)}
                                            disabled={!search.category_id}
                                            style={{ width: '180px' }}
                                        >
                                            <option value=''>All Subcategories</option>
                                            {subCategoryList.map((sub) => (
                                                <option key={sub.id} value={sub.id}>{sub.name}</option>
                                            ))}
                                        </select>
                                        <div style={{ width: '150px' }}>
                                            <StatusFilter
                                                data={showFilterlist}
                                                prepareSearch={prepareSearch}
                                                value={search.status === undefined ? '' : String(search.status)}
                                            />
                                        </div>
                                        <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary">Reset Filter</button>
                                    </div>
                                </div>
                            </div>
                            <div className='page-header-right ms-auto d-flex flex-wrap align-items-center' style={{ gap: '8px' }}>
                                {/* The spreadsheet actions share one menu — four buttons in a row left
                                    no space for a fifth, and only Create is used often enough to stay out. */}
                                <div className="dropdown">
                                    <button className="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        Bulk Actions
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end">
                                        <li><h6 className="dropdown-header">Menu Items</h6></li>
                                        <li><div className="dropdown-item cp" onClick={triggerFileInput}><i className="ti ti-upload" aria-hidden="true"></i> Import</div></li>
                                        <li><div className="dropdown-item cp" onClick={handleExport}><i className="ti ti-download" aria-hidden="true"></i> Export</div></li>
                                        <li><a className="dropdown-item" href={SampleFileCsv} download><i className="ti ti-file" aria-hidden="true"></i> Sample csv file</a></li>
                                        <li><a className="dropdown-item" href={SampleFileXls} download><i className="ti ti-file" aria-hidden="true"></i> Sample xls file</a></li>
                                        <li><a className="dropdown-item" href={SampleFileXlsx} download><i className="ti ti-file" aria-hidden="true"></i> Sample xlsx file</a></li>
                                        <li><hr className="dropdown-divider" /></li>
                                        <li><h6 className="dropdown-header">Recipes</h6></li>
                                        <li><div className="dropdown-item cp" onClick={triggerRecipeFileInput}><i className="ti ti-upload" aria-hidden="true"></i> Import</div></li>
                                        <li><div className="dropdown-item cp" onClick={downloadRecipeSample}><i className="ti ti-file" aria-hidden="true"></i> Export sample file</div></li>
                                        <li><hr className="dropdown-divider" /></li>
                                        <li><h6 className="dropdown-header">Pricing</h6></li>
                                        <li><div className="dropdown-item cp" onClick={triggerPricingFileInput}><i className="ti ti-upload" aria-hidden="true"></i> Import</div></li>
                                        <li><div className="dropdown-item cp" onClick={downloadPricingSample}><i className="ti ti-file" aria-hidden="true"></i> Export sample file</div></li>
                                    </ul>
                                </div>
                                <input type="file" accept=".xls,.xlsx,.csv" onChange={handleFileChange} ref={fileInputRef} style={{ display: 'none' }}
                                />
                                <input type="file" accept=".xls,.xlsx" onChange={handleRecipeFileChange} ref={recipeFileInputRef} style={{ display: 'none' }}
                                />
                                <input type="file" accept=".xls,.xlsx" onChange={handlePricingFileChange} ref={pricingFileInputRef} style={{ display: 'none' }}
                                />
                                {checkPermission('store_menu_items', 'add') ?
                                <button className="btn btn-primary" type="button" onClick={(e) => navigate(`/company/menu/menu/menu_items/add?pageno=${page}`)}>Create Menu Item</button>
                                : '' }
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                    <th width="15%">
                                            <div className='sorting_column'>
                                                <span>Item ID </span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="id" />
                                            </div>
                                        </th>
                                        <th width="15%">
                                            <div className='sorting_column'>
                                                <span>SKU </span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="sku" />
                                            </div>
                                        </th>
                                        <th width="15%">
                                            <div className='sorting_column'>
                                                <span>Name</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="item_name" />
                                            </div>
                                        </th>
                                        <th width="15%">
                                            <div className='sorting_column'>
                                                <span>Name (arabic)</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="item_name_ar" />
                                            </div>
                                        </th>

                                        <th width="15%">
                                            <span>Primary category</span>
                                        </th>
                                        <th width="15%">
                                            <span>Secondary category</span>
                                        </th>
                                        <th className='status_head text-center' width="10%">Status</th>
                                        <th className='action_head text-end' width="10%">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={11}><Loader /></td>
                                        </tr> : <>
                                            {list.length ? list.map((row, i) => (
                                                <tr key={i}> 
                                                    <td>{row?.id}</td>
                                                    <td>{row?.sku}</td>
                                                    <td>{capitalizeFirstLetter(row?.item_name)}</td>
                                                    <td>{capitalizeFirstLetter(row?.item_name_ar)}</td>
                                                    <td>{capitalizeFirstLetter(row?.menu_category?.menu_category?.name)}</td>
                                                    <td>{capitalizeFirstLetter(row?.menu_category?.name)}</td>
                                                    <td>
                                                        <div className="form-check form-switch w-25 mx-auto">
                                                            <input className="form-check-input" type="checkbox" id="status-change" name="status" checked={row.status == 1 ? 'checked' : ''} onClick={() => { ChangeStatus(row.id, row.status == 1 ? 0 : 1) }} />
                                                            <label className="form-check-label" htmlFor="status-change"></label>
                                                        </div>
                                                    </td>
                                                    <td className='text-end'>
                                                        <div className="dropdown  d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                            {checkPermission('store_menu_items', 'view') ?
                                                                <li><div className='dropdown-item' onClick={() => { handleView(row.id) }}><i className="ti ti-eye" aria-hidden="true"></i> View</div></li>
                                                                : '' }
                                                             {checkPermission('store_menu_items', 'edit') ?   
                                                                <li><div className='dropdown-item' onClick={() => { handleEdit(row.id) }}><i className="ti ti-edit" aria-hidden="true"></i> Edit</div></li>
                                                                : ''}
                                                            {checkPermission('store_menu_items', 'delete') ?
                                                                <li> <div className='dropdown-item' onClick={() => { deleteFunction(row.id) }}><i className="ti ti-trash" aria-hidden="true"></i> Delete</div></li>
                                                                : '' }
                                                            {checkPermission('store_menu_items', 'add') ?
                                                                <li> <div className='dropdown-item' onClick={() => { copyOutletFunction(row) }}><i className="ti ti-copy" aria-hidden="true"></i> Copy menu item</div></li>
                                                                : '' }

                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={11} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No Record.</p>
                                                </td>
                                            </tr>}
                                        </>}
                                </tbody>

                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "outlet-management", path: "/company/menu/menu/menu_items/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="top-right"
                    hideProgressBar={false}
                    autoClose={true | 1000}
                    newestOnTop={true}
                    closeOnClick={false}
                    draggable={false}
                    rtl={false}
                />
            </div>

        </>
    );
}

export default MenuItemList